import { useQuery } from "@tanstack/react-query";

import { API, graphqlOperation } from "aws-amplify";

import { listTags } from "@/graphql/queries";

type categoryTags = "Sport" | "Music" | "Food" | "Miscellaneous" | "Book" | "Movie" | "Vacation"

export function filterCategories(data: any) {
  const allowedCategories = ["Music", "Vacation", "Food"];
  const filteredData = data.filter((item: any) => allowedCategories.includes(item.category));
  return filteredData;
}

const fetchInterest = async (type?: "INTEREST" | "SKILL" | "EXPERTISE") => {
  const response: any = await API.graphql(
    graphqlOperation(listTags, {
      limit: 1000,
      filter: {
        type: { eq: type || "INTEREST" },
      },
    }),
  );
  const records: any[] = response?.data?.listTags?.items ?? [];

  return filterCategories(records);
};

const fetchTags = async (payload: { category?: categoryTags }) => {
  const response: any = await API.graphql(
    graphqlOperation(listTags, {
      limit: 1000,
      filter: {
        category: {
          eq: payload?.category,
        },
      },
    }),
  );
  const records: any[] = response?.data?.listTags?.items ?? [];
  return records;
};

const useListInterest = () => {
  return useQuery({
    queryKey: ["KEY_LIST_INTEREST"],
    queryFn: () => fetchInterest(),
  });
};

const useListSkills = () => {
  return useQuery({
    queryKey: ["KEY_LIST_SKILLS"],
    queryFn: () => fetchInterest("SKILL"),
  });
};

const useListExpertise = () => {
  return useQuery({
    queryKey: ["KEY_LIST_EXPERTISES"],
    queryFn: async () => {
      const response: any = await API.graphql(
        graphqlOperation(listTags, {
          limit: 1000,
          filter: {
            type: { eq: "EXPERTISE" },
          },
        }),
      );
      const records: any[] = response?.data?.listTags?.items ?? [];
      return records;
    },
  });
};

const useListTags = (payload: { category?: categoryTags, type?: "EXPERTISE" | "SKILL" | "INTEREST" } = {}) => {
  return useQuery({
    queryKey: [`KEY_LIST_TAGS_${payload?.category}`],
    queryFn: () => fetchTags(payload),
  });
};


export { useListInterest, useListTags, useListSkills, useListExpertise };
